import React from 'react';

import logoMini from '../../assets/img/geko_logo_mini.png';
import logoAlt from '../../assets/img/geko_full_logo.svg';

/**
 * Brand header (logo + wordmark) reusable across screens.
 * Props:
 * - variant: 'lg' | 'md' | 'sm' (size preset)
 * - align: 'left' | 'center' | 'right'
 * - showWallet: show the "WALLET" word (default true)
 * - showChevron: show a small ▼ chevron after the wordmark (default false)
 * - onChevronClick: optional handler to toggle menus etc.
 * - className: optional extra classes
 */
export default function Brand ({
  variant = 'lg',
  align = 'left',
  showWallet = true,
  showChevron = false,
  onChevronClick,
  className = ''
}) {

  return (
    <header className={`brand brand--${variant} brand--${align} ${className}`} role="banner">
      <img
        className = "brand__logo"
        src       = { logoMini }
        onError   = { (e) => { e.currentTarget.src = logoAlt; } }
        alt       = "Geko Wallet logo"
      />
      <span className="brand__wordmark" aria-label="Geko cert">
        <span className="brand__geko">GEKO</span>
        { showWallet && <span className="brand__wallet">CERT</span>}
        { showChevron && (
          <button
            type="button"
            className="brand__chev"
            aria-label="Apri menu"
            onClick={onChevronClick}>
            ▾
          </button>
        )}
      </span>
    </header>
  );

};
